import PropTypes from 'prop-types';
import Container from '@/components/Container';
import Link from '@/components/Link';
import Brand from '@/view/Brand';
import Footer from '@/view/Footer';

const defaultProps = {};

const propTypes = {
  children: PropTypes.node.isRequired,
};

export default function CleanLayout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <header className="py-4 lg:py-6">
        <Container>
          <div className="flex w-full items-center">
            <Brand />
            <div className="ml-auto">
              <Link
                className="font-semibold text-lg tracking-tight"
                href="/contacto"
              >
                Contáctenos
              </Link>
            </div>
          </div>
        </Container>
      </header>
      <div className="w-full flex flex-1 lg:items-stretch">{children}</div>
      <Footer />
    </div>
  );
}

CleanLayout.defaultProps = defaultProps;
CleanLayout.propTypes = propTypes;
